import {Button} from '@vector';
import styles from './VideoSection.module.css';

/**
 * Same native `<video>` markup as `Home.js`/the original `sections` video - deliberately not
 * touched (no HLS, no swap to the Video.js-based `VideoPlayer.js`). Only the surrounding section,
 * heading and gallery-link chrome are restyled.
 */
export default function VideoSection({content}) {
    const words = content.heading.trim().split(' ');
    const highlight = words.pop();
    const lead = words.join(' ');

    return (
        <section className={styles.section} aria-labelledby="home-video">
            <div className={styles.inner}>
                <h2 id="home-video" className={styles.heading}>
                    {lead} <span className={styles.highlight}>{highlight}</span>
                </h2>

                <div className={styles.videoFrame}>
                    <video controls preload="none" poster={content.poster}>
                        {content.sources.map((source) => (
                            <source key={source.src} src={source.src} type={source.type}/>
                        ))}
                        Your browser cannot play this video.
                    </video>
                </div>

                <div className={styles.actions}>
                    <Button surface="base" size="large" href={content.galleryHref} target="_blank"
                            rel="noopener noreferrer">
                        {content.actionLabel}
                    </Button>
                    <p className={styles.hint}>{content.webinarNote}</p>
                </div>
            </div>
        </section>
    );
}
